// src/auth/authService.js

import axios from "axios";
import createEnvironment from "../globel";
import { saveLocalStorage } from "../utils/localStorage";
const ENV_VAR = createEnvironment();
const BASE_URL = ENV_VAR.BASE_URL;
export const refreshToken = async () => {
    try {
        const res = await axios.post(
            `${BASE_URL}/auth/login/v2/refresh`,
            {},
            {
                withCredentials: true,
            }
        );
        const data = res.data;
        const access_token = data.access_token;
        saveLocalStorage("access_token", access_token);
        saveLocalStorage("USER_AUTH", access_token);
        return access_token;
    } catch (err) {
        console.error("Refresh error:", err);
        throw err;
    }
};